import Styles from './styles.module.css';
import React from 'react';
import { useState, useEffect } from 'react';
import DefaultInput1 from '../../../package/1-input/index';
import DefaultTextarea1 from '../../../package/1-textarea/index';
import DefaultImage from './../../../../image/default/wait.png';
import DefaultTitle from '../../../package/title/index';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { ImCross } from "react-icons/im";
import { IoImageOutline } from "react-icons/io5";
import ErrorMessage from '../../../package/error/index';

type interviewsData = {
  isCompleted: boolean,
  count: number,
  item1: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item2: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item3: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item4: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item5: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item6: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
};

type RecruitInterview = {
  documentId: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  interviews: interviewsData;
  setInterviews: React.Dispatch<React.SetStateAction<interviewsData>>;

  interviewImage1File: File | null; setInterviewImage1File: React.Dispatch<React.SetStateAction<File | null>>;
  interviewImage2File: File | null; setInterviewImage2File: React.Dispatch<React.SetStateAction<File | null>>;
  interviewImage3File: File | null; setInterviewImage3File: React.Dispatch<React.SetStateAction<File | null>>;
  interviewImage4File: File | null; setInterviewImage4File: React.Dispatch<React.SetStateAction<File | null>>;
  interviewImage5File: File | null; setInterviewImage5File: React.Dispatch<React.SetStateAction<File | null>>;
  interviewImage6File: File | null; setInterviewImage6File: React.Dispatch<React.SetStateAction<File | null>>;
};

type InterviewItem = {
  name: string;
  title: string;
  desc: string;
  image: string;
  file?: File;
};

type Interviews = {
  count: number;
  items: InterviewItem[];
  isCompleted: boolean;
};

interface RecruitInterviewProps {
  documentId: string;
  setChangeData: (b: boolean) => void;
  interviews: Interviews;
  setInterviews: (v: Interviews) => void;
  interviewImageFiles: (string | File | null)[];
  setInterviewImageFiles: ((v: (string | File | null)[]) => void)[];
}

const RecruitInterview: React.FC<RecruitInterview> = ({ documentId, setChangeData, interviews, setInterviews, interviewImage1File, setInterviewImage1File, interviewImage2File, setInterviewImage2File, interviewImage3File, setInterviewImage3File, interviewImage4File, setInterviewImage4File, interviewImage5File, setInterviewImage5File, interviewImage6File, setInterviewImage6File, }) => {



  const [errorMessage, setErrorMessage] = useState("");
  const [banner, setBanner] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  
  
  const [time, setTime] = useState(0);
  useEffect(() => {
    var timeInit = new Date().getTime();
    setTime(timeInit);
    
    setInterviewImage1File(null);
    setInterviewImage2File(null);
    setInterviewImage3File(null);
    setInterviewImage4File(null);
    setInterviewImage5File(null);
    setInterviewImage6File(null);
  }, [ ]);
    
  // -----------------------------
  // 共通：画像URL生成
  // -----------------------------
  const getInterviewImageUrl = (image: string) => {
    if (!image) return "";

    return `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/interview%2Fresize_images%2F${image}_500x500?alt=media&token=${time}`;
  };

  // -----------------------------
  // 入力チェック
  // -----------------------------
  const validate = (): boolean => {
    for (let i = 0; i < interviews.count; i++) {

      type InterviewKey = "item1" | "item2" | "item3" | "item4" | "item5" | "item6";
      const key = `item${i + 1}` as InterviewKey;
      const item = interviews[key];

      const imageFile =
        i === 0 ? interviewImage1File :
        i === 1 ? interviewImage2File :
        i === 2 ? interviewImage3File :
        i === 3 ? interviewImage4File :
        i === 4 ? interviewImage5File :
        interviewImage6File;

      if (!item.image && !imageFile) {
        setErrorMessage(`No.${i + 1} インタビューの写真を添付してください。`);
        window.scrollTo(0, 0);
        return false;
      }

      if (!item.name) {
        setErrorMessage(`No.${i + 1} インタビューの氏名を入力してください。`);
        window.scrollTo(0, 0);
        return false;
      }

      if (!item.title) {
        setErrorMessage(`No.${i + 1} インタビューの役職を入力してください。`);
        window.scrollTo(0, 0);
        return false;
      }

      if (!item.desc) {
        setErrorMessage(`No.${i + 1} インタビューの詳細を入力してください。`);
        window.scrollTo(0, 0);
        return false;
      }
    }

    setErrorMessage("");
    return true;
  };

  const [ uploading, setUploading ] = useState(false);

  // -----------------------------
  // 保存
  // -----------------------------
  const save = async (isCompleted: boolean) => {
    setErrorMessage("");
    if (isCompleted) {
      if (interviews.count === 0) {
        setErrorMessage("インタビューを2つ以上入力してください。");
        return
      } else {
        if (!validate()) return;
      }
    }
    setUploading(true);

    const db = getFirestore();
    const storage = getStorage();

    const dataToSend = {
      ...interviews,
      isCompleted,
      time: new Date(),
    };

    let ok = false;

    try {
      setIsLocked(true);

      const files = [
        interviewImage1File,
        interviewImage2File,
        interviewImage3File,
        interviewImage4File,
        interviewImage5File,
        interviewImage6File,
      ];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file instanceof File) {
          const storageRef = ref(storage, `/interview/${documentId}_${i + 1}`);
          await uploadBytes(storageRef, file);
        }
      }

      await updateDoc(doc(db, "recruits", documentId), {
        interviews: dataToSend,
      });

      setChangeData(false);
      ok = true;

    } catch (error) {
      console.error("🔥 保存に失敗:", error);
      setErrorMessage('保存に失敗しました。時間をおいてもう一度お試しください。');
    } finally {
      setUploading(false);
      // 保存できたときだけ「保存しました」を出す(失敗時に出ていたバグの修正)。
      if (ok) {
        setBanner(true);
        setTimeout(() => setBanner(false), 1500);
      }
    }
  };

  // -----------------------------
  // 画像変更
  // -----------------------------
  const interviewImageFiles = [
    interviewImage1File, interviewImage2File, interviewImage3File,
    interviewImage4File, interviewImage5File, interviewImage6File,
  ];
  const interviewImageSetters = [
    setInterviewImage1File, setInterviewImage2File, setInterviewImage3File,
    setInterviewImage4File, setInterviewImage5File, setInterviewImage6File,
  ];

  const handleImageChange = (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const picked = e.target.files?.[0];
    e.target.value = '';
    if (!picked) return;

    const file = picked;

    const imageKey =
      index === 0 ? "interviewImage1File" :
      index === 1 ? "interviewImage2File" :
      index === 2 ? "interviewImage3File" :
      index === 3 ? "interviewImage4File" :
      index === 4 ? "interviewImage5File" :
      "interviewImage6File";

    // プレビュー用state更新
    if (imageKey === "interviewImage1File") setInterviewImage1File(file);
    if (imageKey === "interviewImage2File") setInterviewImage2File(file);
    if (imageKey === "interviewImage3File") setInterviewImage3File(file);
    if (imageKey === "interviewImage4File") setInterviewImage4File(file);
    if (imageKey === "interviewImage5File") setInterviewImage5File(file);
    if (imageKey === "interviewImage6File") setInterviewImage6File(file);

    // Firestore用のimageID更新
    setInterviews((prev: any) => {
      const key = `item${index + 1}` as const;

      return {
        ...prev,
        [key]: {
          ...prev[key],
          image: `${documentId}_${index + 1}`,
        },
      };
    });
  };

  const handleRemoveImage = (index: number) => {
    interviewImageSetters[index](null);
    setInterviews((prev: any) => {
      const key = `item${index + 1}` as const;
      return { ...prev, [key]: { ...prev[key], image: '' } };
    });
    setChangeData(true);
  };

  // 従業員写真の添付フィールド（店舗写真・写真で見ると同じテイスト）
  const renderPhotoField = (index: number, item: { image: string }) => {
    const file = interviewImageFiles[index];
    const previewSrc = file
      ? URL.createObjectURL(file)
      : item.image
        ? getInterviewImageUrl(item.image)
        : '';
    const filled = previewSrc !== '';

    return (
      <>
        <p className={Styles.store_input_photo_title}>従業員写真 ※</p>
        <div className={Styles.photoSingle}>
          <label className={filled ? `${Styles.photoBox} ${Styles.photoBox_portrait} ${Styles.photoBox_filled}` : `${Styles.photoBox} ${Styles.photoBox_portrait}`}>
            {filled ? (
              <img
                className={Styles.photoPreview}
                src={previewSrc}
                alt=""
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = DefaultImage;
                }}
              />
            ) : (
              <span className={Styles.photoPlaceholder}>
                <IoImageOutline className={Styles.photoPlaceholderIcon} />
                写真を追加
              </span>
            )}
            <input
              type="file"
              accept="image/*"
              className={Styles.hiddenInput}
              onChange={handleImageChange(index)}
            />
          </label>
          {filled && (
            <button
              type="button"
              className={Styles.photoRemove}
              aria-label="削除"
              onClick={() => handleRemoveImage(index)}
            >
              <ImCross />
            </button>
          )}
        </div>
      </>
    );
  };

  return (
    <>
    {errorMessage !== '' ? <ErrorMessage message={errorMessage} /> : <></> }
    {banner && <div className={Styles.banner}>保存しました。</div>}

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.title_edit}>
      <h4>インタビュー</h4>
      <div className={Styles.title_edit_btn}>
        <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
        <button className={Styles.save_box_save} onClick={() => save(true)}>保存</button>
      </div>
    </div>

    <div className={Styles.test_box}>
      
      <DefaultTitle title={'記載数 ※'} />
      <select className={Styles.select}
        value={interviews.count} onChange={(e) => {setInterviews(prev => ({...prev, count: Number(e.target.value)})); setChangeData(true)}}>
        <option value={0}>0つ</option>
        <option value={2}>2つ</option>
        <option value={4}>4つ</option>
        <option value={6}>6つ</option>
      </select>

    </div>

    {(1 <= Number(interviews.count) && Number(interviews.count) <= 6) && (
    <div className={Styles.test_box}>

      {renderPhotoField(0, interviews.item1)}

      <DefaultInput1
        error={false}
        title={'氏名 ※'} length={10} place={''}
        value={interviews.item1.name} setValue={(val: string) => {setInterviews(prev => ({...prev, item1: {...prev.item1, name: val}})); setChangeData(true)}}
        desc={''}  hint={{title: "", desc: ""}} />

      <DefaultInput1
        error={false}
        title={'役職 ※'} length={10} place={''}
        value={interviews.item1.title} setValue={(val: string) => {setInterviews(prev => ({...prev, item1: {...prev.item1, title: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultTextarea1
        error={false}
        title={'詳細 ※'} length={100} place={''}
        value={interviews.item1.desc} setValue={(val: string) => {setInterviews(prev => ({...prev, item1: {...prev.item1, desc: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}}
      />
    
    </div>
    )}

    {(2 <= Number(interviews.count) && Number(interviews.count) <= 6) && (
    <div className={Styles.test_box}>

      {renderPhotoField(1, interviews.item2)}

      <DefaultInput1
        error={false}
        title={'氏名 ※'} length={10} place={''}
        value={interviews.item2.name} setValue={(val: string) => {setInterviews(prev => ({...prev, item2: {...prev.item2, name: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultInput1
        error={false}
        title={'役職 ※'} length={10} place={''}
        value={interviews.item2.title} setValue={(val: string) => {setInterviews(prev => ({...prev, item2: {...prev.item2, title: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultTextarea1
        error={false}
        title={'詳細 ※'} length={100} place={''}
        value={interviews.item2.desc} setValue={(val: string) => {setInterviews(prev => ({...prev, item2: {...prev.item2, desc: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}}
      />

    </div>
    )}


    {(3 <= Number(interviews.count) && Number(interviews.count) <= 6) && (
    <div className={Styles.test_box}>

      {renderPhotoField(2, interviews.item3)}

      <DefaultInput1
        error={false}
        title={'氏名 ※'} length={10} place={''}
        value={interviews.item3.name} setValue={(val: string) => {setInterviews(prev => ({...prev, item3: {...prev.item3, name: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultInput1
        error={false}
        title={'役職 ※'} length={10} place={''}
        value={interviews.item3.title} setValue={(val: string) => {setInterviews(prev => ({...prev, item3: {...prev.item3, title: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultTextarea1
        error={false}
        title={'詳細 ※'} length={100} place={''}
        value={interviews.item3.desc} setValue={(val: string) => {setInterviews(prev => ({...prev, item3: {...prev.item3, desc: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}}
      />

    </div> )}

    {(4 <= Number(interviews.count) && Number(interviews.count) <= 6) &&  (
    <div className={Styles.test_box}>

      {renderPhotoField(3, interviews.item4)}

      <DefaultInput1
        error={false}
        title={'氏名 ※'} length={10} place={''}
        value={interviews.item4.name} setValue={(val: string) => {setInterviews(prev => ({...prev, item4: {...prev.item4, name: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultInput1
        error={false}
        title={'役職 ※'} length={10} place={''}
        value={interviews.item4.title} setValue={(val: string) => {setInterviews(prev => ({...prev, item4: {...prev.item4, title: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultTextarea1
        error={false}
        title={'詳細 ※'} length={100} place={''}
        value={interviews.item4.desc} setValue={(val: string) => {setInterviews(prev => ({...prev, item4: {...prev.item4, desc: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}}
      />

    </div> )}

    {(5 <= Number(interviews.count) && Number(interviews.count) <= 6) && (
    <div className={Styles.test_box}>

      {renderPhotoField(4, interviews.item5)}

      <DefaultInput1
        error={false}
        title={'氏名 ※'} length={10} place={''}
        value={interviews.item5.name} setValue={(val: string) => {setInterviews(prev => ({...prev, item5: {...prev.item5, name: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultInput1
        error={false}
        title={'役職 ※'} length={10} place={''}
        value={interviews.item5.title} setValue={(val: string) => {setInterviews(prev => ({...prev, item5: {...prev.item5, title: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultTextarea1
        error={false}
        title={'詳細 ※'} length={100} place={''}
        value={interviews.item5.desc} setValue={(val: string) => {setInterviews(prev => ({...prev, item5: {...prev.item5, desc: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}}
      />

    </div> )}

    {(6 <= Number(interviews.count) && Number(interviews.count) <= 6) && (
    <div className={Styles.test_box}>

      {renderPhotoField(5, interviews.item6)}

      <DefaultInput1
        error={false}
        title={'氏名 ※'} length={10} place={''}
        value={interviews.item6.name} setValue={(val: string) => {setInterviews(prev => ({...prev, item6: {...prev.item6, name: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultInput1
        error={false}
        title={'役職 ※'} length={10} place={''}
        value={interviews.item6.title} setValue={(val: string) => {setInterviews(prev => ({...prev, item6: {...prev.item6, title: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}} />

      <DefaultTextarea1
        error={false}
        title={'詳細 ※'} length={100} place={''}
        value={interviews.item6.desc} setValue={(val: string) => {setInterviews(prev => ({...prev, item6: {...prev.item6, desc: val}})); setChangeData(true)}}
        desc={''} hint={{title: "", desc: ""}}
      />

    </div> )}
    </>
  );
}

export default RecruitInterview;
